<template>
    <router-view></router-view>
</template>

<script setup lang="ts">

</script>
<style>
#app {
    font-family: Roboto, Helvetica, Arial, sans-serif;
}
</style>